var map = {
	"./c_baijin.png": 1153,
	"./c_huangjin.png": 9716,
	"./c_meiguijin.png": 6679,
	"./logo.png": 3153,
	"./logo_hx.png": 4442,
	"./yang.png": 2315,
	"./yin.png": 3566,
	"./z_fenzuan.png": 9304,
	"./z_huangzuan.png": 2256,
	"./z_lanzuan.png": 8774,
	"./z_wusezuan.png": 1059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;